import { useState } from 'react'
import { FormControl, MenuItem, Select } from '@mui/material'
import { Typography } from '@achieve/ascend'
import { KeyboardArrowDown } from '@mui/icons-material'

export const DatSelectField = ({
  selectItemList = [
    { value: '20000', label: '$20,000' },
    { value: '30000', label: '$30,000' },
    { value: '40000', label: '$40,000' },
    { value: '50000', label: '$50,000' },
  ],
  onChange = () => {},
  defaultSelectedValue = '',
}) => {
  const [value, setValue] = useState(defaultSelectedValue || selectItemList?.[0]?.value)
  const selectItems = selectItemList.map(({ label, value }, idx) => (
    <MenuItem key={label} value={value} autoFocus={idx === 0}>
      <Typography variant="headingMd" fontWeight="bold" color="primary">
        {label}
      </Typography>
    </MenuItem>
  ))
  return (
    <div className="w-full">
      <FormControl fullWidth>
        <Select
          displayEmpty
          IconComponent={KeyboardArrowDown}
          variant="standard"
          value={value}
          onChange={(e) => {
            onChange(e)
            setValue(e.target.value)
          }}
          fullWidth
          data-testid="dat-select-field"
          labelId="subtitle"
          className="border-[3px] border-[rgb(51,0,255)] rounded-md border-solid px-4 py-2 text-[22px]"
          sx={{
            svg: {
              color: 'rgb(51,0,255)', // Tailwind blue-500
              marginRight: '10px',
            },
            '&:before, &:after': {
              display: 'none',
            },
            '& .MuiInput-input:focus': {
              backgroundColor: 'transparent',
            },
          }}
        >
          {selectItems}
        </Select>
      </FormControl>
    </div>
  )
}
